import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useSiteSettings } from './SiteSettingsContext';

export default function NotFound() {
  const { settings: site } = useSiteSettings();
  const store = site.store_copy || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="store-page not-found-page">
      <Helmet>
        <title>{store.seo_notfound_title}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="container store-page__container text-center py-5">
        <p className="not-found-page__code" aria-hidden>
          404
        </p>
        <h1 className="store-page__title mb-3">{store.notfound_title}</h1>
        <p className="store-page__lead store-page__lead--narrow mx-auto mb-4">{store.notfound_lead}</p>
        <div className="d-flex flex-wrap gap-2 justify-content-center">
          <Link to="/shop" className="btn btn-primary btn-lg rounded-pill px-4 store-cta">
            {store.notfound_shop_button}
          </Link>
          <Link to="/" className="btn btn-outline-secondary btn-lg rounded-pill px-4">
            {store.notfound_home_button}
          </Link>
        </div>
      </div>
    </div>
  );
}
